import { Component } from "react";

class KeyboardListener extends Component<{ onEscape: () => void; children: React.JSX.Element }> {
	componentDidMount() {
		window.addEventListener("keydown", this.onKeyPress);
	}
	componentWillUnmount() {
		window.removeEventListener("keydown", this.onKeyPress);
	}

	onKeyPress = (e: KeyboardEvent) => {
		if (e.keyCode === 27) {
			this.props.onEscape();
		}
	};

	render() {
		return this.props.children;
	}
}

export default KeyboardListener;
